import React from 'react';
import { Box, Typography, useMediaQuery, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import cesty from '../../../../src/assets/cesty-pathways.png';
import { useTranslation } from 'react-i18next';

const InnerHeader = ({
  icon,
  color,
  title,
  text,
  loginMessage,
  showLoginMessage = true,
  hideRightImage = false,
  iconSize,
}) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();

  return (
    <Box style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      {icon && (
        <img
          src={icon}
          style={{
            height: iconSize ? iconSize : matchesXs ? '60px' : '80px',
            width: iconSize ? iconSize : matchesXs ? '60px' : '80px',
            filter: color
              ? 'brightness(0) saturate(100%) invert(20%) sepia(100%) saturate(2000%) hue-rotate(200deg) brightness(0.7)'
              : 'none',
            objectFit: 'contain',
          }}
        />
      )}
      <Box sx={{ pl: icon ? 4 : 0 }}>
        <Typography
          style={{
            fontFamily: 'Mark-Medium',
            fontSize: '34px',
            color: '#01486B',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
        <Typography
          style={{
            fontFamily: 'Mark-Medium',
            fontSize: '20px',
            lineHeight: '30px',
            color: '#01486B',
          }}
        >
          {text}
        </Typography>
        {showLoginMessage !== false && typeof window !== 'undefined' && !localStorage.getItem('cesty-token') && (
          <Typography
            sx={{
              fontSize: '14px',
              color: '#707070',
              fontFamily: 'Mark-Medium',
              pt: 1,
            }}
          >
            {loginMessage ? (
              <>
                {loginMessage}{' '}
                <Link
                  to="/login"
                  style={{
                    color: '#01486B',
                    fontWeight: 500,
                    textDecoration: 'underline',
                  }}
                >
                  {t('login')}
                </Link>
              </>
            ) : (
              <>
                {t('loginToApplyFull')}{' '}
                <Link
                  to="/login"
                  style={{
                    color: '#01486B',
                    fontWeight: 500,
                    textDecoration: 'underline',
                  }}
                >
                  {t('loginToApply')}
                </Link>
              </>
            )}
          </Typography>
        )}
      </Box>
      {!matchesXs && !hideRightImage && (
        <img
          src={cesty}
          style={{
            height: matchesXs ? '60px' : '80px',
            marginLeft: 'auto',
          }}
        />
      )}
    </Box>
  );
};

export default InnerHeader;
